import { SERVICE_DETAILS_MAXLENGTH } from './ServiceConstants';

export const EVENT_VALIDATION_ERRORS = {
  eventId: 'Event ID required',
  invalidEventId: 'Event id not valid',
  eventName: 'Event name is required',
  invalidEventName: 'Event name is invalid',
  existingEventName: 'Event name already exists',
  eventVerificationIssue: 'Network failure',
  schemaName: 'Schema name is required',
  invalidSchemaName: 'Schema name is invalid',
  existingSchemaName: 'Schema name already exists',
  invalidAvroJson: 'Event schema is invalid',
  category: 'Category is required',
  invalidCategory: 'Category name is invalid',
  version: 'Schema version is invalid',
  invalidVersion: 'Schema version is invalid',
  invalidDescription: 'Description is invalid',
  networkError: 'undefined',
  descriptionRequired: 'Description is required',
  avroJsonRequired: 'Event schema is required'
};

export const SERVICE_OPERATION_KEY_NAMES = {
  serviceOperationName: 'serviceOperationName',
  queryParamValue: 'queryParamValue',
  headerParamValue: 'headerParamValue',
  operationURL: 'operationURL',
  requestAttributes: 'requestAttributes',
  responseAttributes: 'responseAttributes',
  retryErrorCode: 'retryErrorCode',
  retryCount: 'retryCount',
  timeOut: 'timeOut'
};

export const SERVICE_VALIDATION_ERRORS = {
  serviceId: 'Service Id not valid',
  serviceName: 'Service name is invalid',
  existingServiceName: 'Service name already exists',
  serviceCheckError: 'Network failure',
  endPoint: 'Service endpoint is invalid',
  authName: 'Authentication key name is invalid',
  serviceDescription: 'Description is invalid',
  serviceOpsURI: 'Operation URI is invalid',
  serviceOperationName: 'Service operation name is invalid',
  serviceDescriptionRequired: 'Service description is required',
  serviceIdRequired: 'Service id is required',
  serviceNameRequired: 'Service name is required',
  authKeyRequired: 'Authentication key is required',
  endPointRequired: 'Service endpoint is required',
  serviceOperationNameRequired: 'Service operation name is required',
  serviceOpsURIRequired: 'Operation URI is required',
  serviceOpsVerbRequired: 'Operation verb is required',
  userNameRequired: 'Username is required',
  userNameInvalid: 'Username is invalid',
  passwordRequired: 'Password is required',
  passwordInvalid: 'Password is invalid',
  authUrlRequired: 'URL is required',
  authUrlInvalid: 'URL is invalid',
  invalidKey: 'Key is invalid',
  invalidValue: 'Value is invalid',
  keyExists: 'This Key has already been added. Please try a different Key.',
  invalidXML: 'XML is invalid',
  invalidNamespace: 'Namespace is invalid',
  namespaceRequired: 'Namespace is required',
  invalidXml: 'Xml-payload is invalid',
  invalidPrefix: 'Prefix is invalid',
  prefixExists: 'This prefix has already been added for namespace. Please try a different prefix.',
};

export const serviceMaxChar = {
  serviceName: SERVICE_DETAILS_MAXLENGTH.serviceNameMaxLength,
  serviceId: SERVICE_DETAILS_MAXLENGTH.serviceNameMaxLength,
  serviceType: SERVICE_DETAILS_MAXLENGTH.serviceNameMaxLength,
  endPoint: SERVICE_DETAILS_MAXLENGTH.endPointMaxLength,
  endpoint: SERVICE_DETAILS_MAXLENGTH.endPointMaxLength,
  authName: SERVICE_DETAILS_MAXLENGTH.authNameMaxLength,
  serviceDescription: SERVICE_DETAILS_MAXLENGTH.serviceDescMaxLength,
  userName: SERVICE_DETAILS_MAXLENGTH.default,
  password: SERVICE_DETAILS_MAXLENGTH.default,
  authUrl: SERVICE_DETAILS_MAXLENGTH.default,
  authType: SERVICE_DETAILS_MAXLENGTH.default,
  authMethod: SERVICE_DETAILS_MAXLENGTH.default,
  paramKey: SERVICE_DETAILS_MAXLENGTH.default,
  paramValue: SERVICE_DETAILS_MAXLENGTH.default,
  headerXml: SERVICE_DETAILS_MAXLENGTH.default,
  namespace: SERVICE_DETAILS_MAXLENGTH.default
};

export const SERVICE_OPERATIONS_ERRORS = {
  serviceOperation: 'Service operation is invalid',
  serviceOperationExist: 'Service operation name already exist. Please try other Name.',
  serviceOperationDuplicateError: 'Service operation already exists. Cannot associate same service operation to multiple services',
  operationURL: 'Operation URI is invalid',
  invalidKey: 'Key is invalid',
  invalidValue: 'Value is invalid',
  queryKeyExists: 'This key has already been added for query path param. Please try a different key.',
  headerKeyExists: 'This key has already been added for header param. Please try a different key.',
  reqAttInvalid: 'Request attribute is invalid',
  resAttInvalid: 'Response attribute is invalid',
  retryErrorCode: 'Error codes are invalid',
  retryCount: 'Retry count is invalid',
  timeOut: 'Timeout is invalid',
  timeOutExceeded: 'Timeout cannot exceed 60 seconds (60000 milliseconds)'
};

export const SERVICE_ASSOCIATION_ERRORS = {
  invalidAttribute: 'JOLT specification is invalid',
  reqAttRequired: 'Request attribute is required',
  resAttRequired: 'Request attribute is required',
};

export const CREATE_SERVICE_FAILED_NETWORK_ERROR = 'Network Error';
export const CREATE_SERVICE_NAME_INVALID_ERROR = 'Service Name already exists';

export const SERVICE_EXCEPTIONS_ERRORS = {
  duplicateCombinationError: 'The Exception combination you have entered has already been added. Please try a different combination',
  errorCodeValue: 'Error code is invalid',
  wrongCombination: 'Ignore and Compensate actions cannot be selected together',
  duplicateErrorCode: 'Error code exists, please try a different code',
  duplicateExceptionName: 'This exception has been added, please edit to make changes',
  emptyExceptionSearch: 'There\'s no result for the entered exception name, please retry'
};

export const SOURCE_REGISTRY_ERRORS = {
  invalidSourceRegistryName: 'Source name is invalid',
  requiredSourceRegistryName: 'Source name is required',
  invalidIdentifiers: 'Identifier is invalid',
  requiredIdentifiers: 'Identifier is required',
  invalidEventName: 'Event name is invalid',
  duplicateIdentifiers: 'This identifier has already been added to this source registry.',
  jsonTransformation: 'JSON is invalid',
  invalidReplyTopicName: 'Reply Topic name is invalid',
  invalidReplyTimeOut: 'Reply Timeout is invalid',
};

export const PATTERN_REGISTRY_ERRORS = {
  invalidPatternRegistryName: 'Pattern name is invalid',
  requiredPatternRegistryName: 'Pattern name is required',
  invalidPatternType: 'Pattern type invalid',
  requiredPatternType: 'Pattern type is required',
  invalidSourceName: 'Source name is invalid', // referred as signal source in backend API
  requiredSourceName: 'Source name is required', // referred as signal source in backend API
  invalidEventName: 'Event name invalid',
  requiredEventName: 'Event name is required',
  invalidAuthor: 'Author is invalid',
  requiredAuthor: 'Author is required',
  invalidOccurrences: 'Occurrences is invalid',
  requiredOccurrences: 'Occurrence is required',
  invalidTimeToLive: 'Time to live is invalid',
  requiredTimeToLive: 'Time to live is required',
  invalidUniqueId: 'Unique id is invalid',
  requiredUniqueId: 'Unique id is required',
  invalidFDName: 'Field definition name is invalid',
  requiredFDName: 'Field definition name is required',
  invalidFDOperator: 'Field definition operator is invalid',
  requiredFDOperator: 'Field definition operator is required',
  invalidFDValue: 'Field definition value is invalid',
  requiredFDValue: 'Field definition value is required',
  invalidCPValue: 'Conversion pattern value is invalid',
  requiredCPValue: 'Conversion pattern value is required',
  invalidFDContentType: 'Field definition content type is invalid',
  requiredFDContentType: 'Field definition content type is required',
  invalidFieldCondition: 'Field condition is invalid',
  requiredFieldCondition: 'Field condition is required',
  invalidFieldN: 'Field definition is invalid',
  requiredFieldN: 'Field definition is required',
  invalidJourneyName: 'Journey name is invalid',
  requiredJourneyName: 'Journey name is required',
  duplicateJourneyName: 'This journey Name has already been added to this pattern registry'
};
